import { render, staticRenderFns } from "./CreateSecondaryContactModal.vue?vue&type=template&id=610094e6"
import script from "./CreateSecondaryContactModal.vue?vue&type=script&lang=js"
export * from "./CreateSecondaryContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports